import React, { useState, useEffect, useContext } from 'react'
import { useRouteMatch, useHistory } from 'react-router-dom'
import objectPath from 'object-path'
import { ConfigContext } from 'contexts/ConfigContext'
import * as actionType from '../../../../store/actions'
import FormBreadcrumb from './Form'
import PageBreadcrumb from './Page'

const PerspectiveBreadCrumb = () => {
  let breadcrumbContent = ''
  let matchPage = useRouteMatch('/:perspective/display/page/:pageCode')
  let matchForm = useRouteMatch('/:perspective/display/form/:formCode')
  const [main, setMain] = useState([])
  const [item, setItem] = useState([])
  const configContext = useContext(ConfigContext)
  const { dispatch } = configContext
  const { perspective, perspectiveMenu = [], menuClick } = configContext.state
  const history = useHistory()
  const pathname = history.location.pathname

  useEffect(() => {
    perspectiveMenu.map((item, index) => {
      if (item.type && item.type === 'group') {
        getCollapse(item, index)
      }
      return false
    })
  }, [menuClick, pathname, perspectiveMenu.length > 0])

  const getCollapse = (item) => {
    if (item.children) {
      item.children.filter((collapse) => {
        if (collapse.type && collapse.type === 'collapse') {
          getCollapse(collapse)
        } else if (collapse.type && collapse.type === 'item') {
          if (menuClick) {
            if (menuClick.id === collapse.id) {
              let groupMenuId = objectPath.get(item, 'menu.data.groupMenuId')
              let mainGroup =
                perspectiveMenu.find((main) => main.id === groupMenuId) || item
              setMain(mainGroup)
              setItem(collapse)
            }
          } else {
            if (collapse.url === pathname) {
              let groupMenuId = objectPath.get(item, 'menu.data.groupMenuId')
              let mainGroup =
                perspectiveMenu.find((main) => main.id === groupMenuId) || item
              setMain(mainGroup)
              setItem(collapse)
              dispatch({
                type: actionType.COLLAPSE_TOGGLE,
                menu: { id: item.id, type: 'sub' },
              })
            }
          }
        }
        return false
      })
    }
  }

  if (objectPath.get(item, 'menu.data.breadcrumb') === false) {
    breadcrumbContent = ''
  } else {
    if (perspective && matchPage) {
      breadcrumbContent = <PageBreadcrumb main={main} item={item} />
    }

    if (perspective && matchForm) {
      breadcrumbContent = (
        <FormBreadcrumb match={matchForm} main={main} item={item} />
      )
    }
  }

  return <React.Fragment>{breadcrumbContent}</React.Fragment>
}

export default PerspectiveBreadCrumb
